export const getScreenConfigurationLabel = (
  screens: {
    width: number;
    height: number;
  }[],
) => {
  let screenSetup = '';

  const numberOfVerticalScreens = screens.filter(
    (screen) => screen.height > screen.width,
  ).length;
  const numberOfHorizontalScreens = screens.filter(
    (screen) => screen.width > screen.height,
  ).length;

  const pluralize = (count: number, label: string) =>
    `${count} ${label}${count === 1 ? '' : 's'}`;

  if (numberOfVerticalScreens > 0 && numberOfHorizontalScreens > 0) {
    screenSetup = `${pluralize(
      numberOfVerticalScreens,
      'vertical screen',
    )} and ${pluralize(numberOfHorizontalScreens, 'horizontal screen')}`;
  } else if (numberOfVerticalScreens > 0) {
    screenSetup = pluralize(numberOfVerticalScreens, 'vertical screen');
  } else if (numberOfHorizontalScreens > 0) {
    screenSetup = pluralize(numberOfHorizontalScreens, 'horizontal screen');
  } else {
    screenSetup = 'No screen';
  }

  return screenSetup;
};
